import React, { Component } from 'react'
import { ExpandableContainer } from './expandable.container'
import { Icon, Link, MenuItem, StickyToBottomContainer } from './primitives.components'
import {
  MenuDownloadAppContainer,
  MenuFrame,
  MenuSocialContainer,
  StaticLinksContainer,
} from './menu.components'

const min = (a, b) => (a < b ? a : b)
const addUtmSource = (link, analyticsName) =>
  `${link}?view_source=menu&view_medium=menu_${analyticsName.replace(/-|_/g, '')}`

export class MenuContainer extends Component {
  static NUM_OF_OPEN_ITEMS = 5
  constructor() {
    super()
    this.state = { showMenu: false }
  }

  componentWillReceiveProps(nextProps) {
    document.body.classList.toggle('no-scroll', !!nextProps.isMenuOpen)
  }
  componentWillUnmount() {
    document.body.classList.remove('no-scroll')
  }

  render() {
    return (
      <MenuFrame {...this.props}>
        {MenuContainer.getMenuItemsInRange(
          this.props.links,
          0,
          min(MenuContainer.NUM_OF_OPEN_ITEMS, this.props.links.length - 1)
        )}
        {this.props.links.length > MenuContainer.NUM_OF_OPEN_ITEMS + 1
          ? <ExpandableContainer>
              <ExpandableContainer.Content>
                {MenuContainer.getMenuItemsInRange(
                  this.props.links,
                  min(MenuContainer.NUM_OF_OPEN_ITEMS, this.props.links.length),
                  -1
                )}
              </ExpandableContainer.Content>
              <ExpandableContainer.Header className="menu__container-list--expandable-header menu-item">
                {this.props.constants.more}
              </ExpandableContainer.Header>
            </ExpandableContainer>
          : null}
        <StickyToBottomContainer className="menu__container-sticky-to-bottom">
          {MenuContainer.getMenuItemsInRange(this.props.links, -1)}
          {this.props.mobile
            ? <MenuDownloadAppContainer
                downloadOurAppText={this.props.constants.download_app}
                // ios={this.props.mobile.ios}
                // android={this.props.mobile.android}
                mobile={this.props.mobile}
              />
            : null}
          {this.props.social
            ? <MenuSocialContainer
                stayUpToDateText={this.props.constants.stay_up_to_date}
                items={this.props.social}
              />
            : null}
          {this.props.staticLinks ? <StaticLinksContainer items={this.props.staticLinks} /> : null}
        </StickyToBottomContainer>
      </MenuFrame>
    )
  }

  static getMenuItemsInRange = (items, start, end) =>
    items.slice(start, end).map((item, index) =>
      <MenuItem key={item.description}>
        <Link
          className="menu-item__link"
          href={addUtmSource(item.url, item.analytics_description)}
          data-analytics-event-category="Navigation"
          data-analytics-event-action="hamburger menu click"
          data-analytics-event-label={item.analytics_description}
          data-analytics-event-value={`position ${start + index}`}
        >
          {item.icon_name
            ? <Icon size="20" className="menu-item__icon" iconName={item.icon_name} />
            : null}
          <div className="menu-item__text">
            {item.description}
          </div>
        </Link>
      </MenuItem>
    )
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/menu/menu.container.js